// extracted by mini-css-extract-plugin
export default {"bannerContainer":"t4iD4luW3k9eOydR7rpw"};